import { PanelUploadForm } from '@/components/forms/PanelUploadForm';
import { uploadPanel } from '@/api/panels';
import { useNavigate, useLocation } from 'react-router-dom';
import { message } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import { getCurrentDeveloperId } from '@/stores/authStore';

/**
 * 面板上传页面
 */
export const PanelUpload = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const developerId = getCurrentDeveloperId();

  /**
   * 处理面板上传
   */
  const handleUpload = async (name: string, version: string, file: File): Promise<void> => {
    try {
      await uploadPanel({ name, version }, file);
      message.success('面板上传成功');
      
      // 上传成功后无效化相关查询
      if (developerId) {
        queryClient.invalidateQueries({ queryKey: ['panels', developerId] });
      }
      
      // 检查是否来自产品编辑页面
      if (location.state?.fromProductEdit) {
        navigate(location.state.from, { replace: true });
      } else {
        navigate('/panels');
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : '上传失败，请检查参数后重试。';
      message.error(errorMessage);
    }
  };

  return (
    <div className="w-full space-y-8">
      {/* 统一页面标题层级 */}
      <div>
        <h1 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="17 8 12 3 7 8"></polyline>
            <line x1="12" y1="3" x2="12" y2="15"></line>
          </svg>
          上传面板
        </h1>
        <p className="text-gray-500 mt-1">上传iOS/Android端面板文件，填写名称和版本后即可关联到产品。</p>
      </div>
      <div className="max-w-2xl w-full">
        <PanelUploadForm onSubmit={handleUpload} />
      </div>
    </div>
  );
};